import moment from 'moment';

//格式化日期 date:日期 format：格式。
export function parseTime(date,format) {
  let formatChar = format ? format.replace(/d/g, "D").replace(/y/g, "Y") : 'YYYY-MM-DD HH:mm:ss';
  return moment(date).format(formatChar)
}

//图片截图转换base64格式
export function convertBase64UrlToFile(urlData) {
  var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte
  //处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new File([ab], new Date().getTime() + '.png');
}

//根据字节截取字符串
/*
 * param str 要截取的字符串
 * param L 要截取的字节长度，注意是字节不是字符，一个汉字两个字节
 * return 截取后的字符串
 */
export function cutStr(str, L) {
  let result = '',
    strlen = str.length, // 字符串长度
    chrlen = str.replace(/[\u0391-\uFFE5]/g, "aa").length; // 字节长度
  if (chrlen <= L) {
    return str;
  }
  for (let i = 0, j = 0; i < strlen; i++) {
    let chr = str.charAt(i);
    if (/[\x00-\xff]/.test(chr)) {
      j++; // ascii码为0-255，一个字符就是一个字节的长度
    } else {
      j += 2; // ascii码为0-255以外，一个字符就是两个字节的长度
    }
    if (j <= L) { // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
      result += chr;
    } else { // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
      return result;
    }
  }
}
// 防抖
export function debounce(fn, wait) {
  let timeout = null
  return function () {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      fn.call(this, ...arguments)
    }, wait);
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js